import React from 'react';
function Html({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path strokeLinecap="round" d="M7 8l-4 4 4 4M17 8l4 4-4 4M9.5 19l5-14" />
    </svg>
  );
}

export default Html;
